<template>
  <div class="cat">
    <h3>{{cat.key}}</h3>
    <h5>{{ catNumber }}</h5>
  </div>
</template>


<script>
export default {
  props: ['cat'],
  computed: {
    catNumber: function () {
      return this.cat.number > 1 ? this.cat.number : 'UNIQUE';
    }
  }
};
</script>

<style>
  .cat{
    background: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 5px #ccc;
    padding: 10px;
    margin: 8px 0;
    width: 280px;
    margin: 15px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .cat h3 {
    font-size: 1.1em;
    color: #2f2f2f;
    font-family: 'Open Sans', serif;
  }
  .cat pre {
    font-size: 1.1em;
    margin-bottom: 10px;
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: inherit;
  }

  @media(max-width: 980px) {
    .cat {
      width: 100%;
      padding: 20px;
    }
    .cat h3 {
      font-size: 3rem;
      padding-left: 2%;
    }
    .cat h5 {
      font-size: 3rem;
      padding-right:2%;
    }
  }

</style>



// WEBPACK FOOTER //
// Cat.vue?53fcf345